import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const MessageMobile = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M25 8H24V7C24 4.243 21.757 2 19 2H11C8.243 2 6 4.243 6 7V25C6 27.757 8.243 30 11 30H19C21.757 30 24 27.757 24 25V16H25C26.654 16 28 14.654 28 13V11C28 9.346 26.654 8 25 8ZM19 28H11C9.346 28 8 26.654 8 25V24H22V25C22 26.654 20.654 28 19 28ZM22 22H8V7C8 5.346 9.346 4 11 4H19C20.654 4 22 5.346 22 7V8H15C13.346 8 12 9.346 12 11V19C12 19.404 12.244 19.769 12.617 19.924C12.741 19.975 12.871 20 13 20C13.26 20 13.516 19.898 13.707 19.707L17.414 16H22V22ZM26 13C26 13.551 25.551 14 25 14H17C16.735 14 16.48 14.105 16.293 14.293L14 16.586V11C14 10.449 14.449 10 15 10H25C25.551 10 26 10.449 26 11V13V13Z" />
	</svg>
);

export default MessageMobile;
